module.exports = __webpack_public_path__ + "66cdc56cf5c323535418b01b09e1384a.svg";